import React from "react";

/* content for main Hero section: */
import HomeHeroIconsDesktopSvg from "./images/home-hero-icons-desktop.svg";
import HomeHeroIconsMobileSvg from "./images/home-hero-icons-mobile.svg";

export const heroTitle = "Icons and Photos For Everything";

export const heroSvgDesktop = HomeHeroIconsDesktopSvg;

export const heroSvgMobile = HomeHeroIconsMobileSvg;

/* content for Collections: */

// Collection Images:
import HikingCamping from "./images/hiking-and-camping.png";
import BackToSchool from "./images/back-to-school.png";
import SummerFruit from "./images/summer-fruit.png";
import FeaturedPhotographer from "./images/featured-photographer.png";

import IconSetBrowse from "./images/icon-set-browse.png";
import IconHouseplants from "./images/icon-houseplants.png";
import ArtificialIntelligence from "./images/artificial-intelligence.svg";
import IconSetPride from "./images/icon-set-pride.svg";
import Education from "./images/education.svg";

export const collectionsTitle =
    "Noun Project is building a global visual language that unites us.";

export const collections = [
    {
        title: "Iconathon",
        subtitle: "Pride Collection",
        url: "/browse/collection-icon/pride-201560/?p=1",
        imageSrcAndTitle: {
            imageSrc: IconSetPride,
            title: "Iconathon"
        },
        type: "darkMode"
    },
    {
        title: "Back to School",
        subtitle: null,
        url: "/search/photos/?q=back+to+school",
        imageSrcAndTitle: {
            imageSrc: BackToSchool,
            title: "Back to School"
        },
        isPhoto: true,
        type: "primary"
    },
    {
        title: "Houseplants",
        subtitle: null,
        url: "/browse/icons/term/houseplants/",
        imageSrcAndTitle: {
            imageSrc: IconHouseplants,
            title: "Houseplants"
        },
        type: "primary"
    },
    {
        title: "Summer Fruit",
        subtitle: null,
        url: "/search/photos/?q=summer+fruit",
        imageSrcAndTitle: {
            imageSrc: SummerFruit,
            title: "Summer Fruit"
        },
        isPhoto: true,
        backgroundSize: "auto 101%",
        type: "primary"
    },
    {
        title: "Artificial Intelligence",
        subtitle: null,
        url:
            "/browse/collection-icon/artificial-intelligence-by-essence-99758/?p=1",
        imageSrcAndTitle: {
            imageSrc: ArtificialIntelligence,
            title: "Artificial Intelligence"
        },
        type: "primary"
    },
    {
        title: "Hiking & Camping",
        subtitle: null,
        url: "/search/photos/?q=hiking+%2B+camping",
        imageSrcAndTitle: {
            imageSrc: HikingCamping,
            title: "Hiking & Camping"
        },
        isPhoto: true,
        type: "primary"
    },
    {
        title: "Education",
        subtitle: null,
        url: "/browse/collection-icon/back-to-school-145841/?p=1",
        imageSrcAndTitle: {
            imageSrc: Education,
            title: "Education"
        },
        type: "primary"
    },
    {
        title: "Featured Photographer",
        subtitle: null,
        url: "/browse/creator/avlien/photos/",
        imageSrcAndTitle: {
            imageSrc: FeaturedPhotographer,
            title: "Featured Photographer"
        },
        isPhoto: true,
        type: "primary"
    },
    {
        title: "Browse New Icons",
        subtitle: null,
        url: "/browse/",
        imageSrcAndTitle: {
            imageSrc: IconSetBrowse,
            title: "Browse New Icons"
        },
        type: "primary"
    }
];

/* content for Recent Posts: */
import RecentPostsImg1 from "./images/posts-top-designers.png";
import RecentPostsImg2 from "./images/posts-conservation-photography.png";
import RecentPostsImg3 from "./images/posts-timothy-goodman.png";

export const recentPostsTitle = "Recent Posts";

export const recentPosts = [
    {
        title: "Top Designers & Illustrators of 2023",
        category: "Creative Inspiration",
        imgSrc: RecentPostsImg1,
        url: "https://thelist.thenounproject.com/",
        target: "_blank",
        imageIsLink: true,
        headingIsLink: true,
        subtitleIsLink: true
    },
    {
        title: "Nature and Conservation Photography",
        category: "Photographer Feature",
        imgSrc: RecentPostsImg2,
        url:
            "https://blog.thenounproject.com/how-conservation-photography-can-help-save-the-planet/",
        target: "_blank",
        imageIsLink: true,
        headingIsLink: true,
        subtitleIsLink: true
    },
    {
        title: "Design Icon: Timothy Goodman",
        category: "Interview Feature",
        imgSrc: RecentPostsImg3,
        url: "https://blog.thenounproject.com/timothy-goodman-design-icon/",
        target: "_blank",
        imageIsLink: true,
        headingIsLink: true,
        subtitleIsLink: true
    }
];

/* Content for Promo section: */
import { PRICING, appsAndPluginsPath, API_LANDING_PAGE } from "data/links";
import Payouts from "core/ReusableIcons/Payouts";
import Computer from "core/ReusableIcons/Computer";
import Api from "core/ReusableIcons/Api";

import AppAppleSvg from "./images/AppAppleSvg";
import AppAdobeSvg from "./images/AppAdobeSvg";
import AppMicrosoftSvg from "./images/AppMicrosoftSvg";
import AppGsuiteSvg from "./images/AppGsuiteSvg";

export const promo = [
    {
        url: PRICING,
        iconName: <Payouts size="xl" title="Pricing &amp; Licenses" />,
        title: "Pricing & Licenses",
        description:
            "All images available as free downloads. Purchase a royalty-free license to support artists and get more options.",
        learnMoreContent: "Learn More"
    },
    {
        url: appsAndPluginsPath,
        iconName: <Computer size="xl" title="Apps &amp; Plugins" />,
        title: "Apps & Plugins",
        description:
            "Drag and drop icons into the software you use. Access vector, png, & pdf from Mac, PowerPoint, Adobe, Google, more.",
        learnMoreContent: [
            {
                icon: <AppAppleSvg title="Apple" />
            },
            {
                icon: <AppAdobeSvg title="Adobe" />
            },
            {
                icon: <AppMicrosoftSvg title="Microsoft" />
            },
            {
                icon: <AppGsuiteSvg title="GSuite" />
            }
        ]
    },
    {
        url: API_LANDING_PAGE,
        iconName: <Api size="xl" title="API" />,
        title: "API",
        description:
            "Access the entire icon collection via our REST API. Reliably supports growth stage to enterprise clients. ",
        learnMoreContent: "Learn More"
    }
];
